import Main from '@/views/Main.vue'

// The code below is used by jest unit test.
// When running unit test, it will replace webpack require.context method with babel plugin 'babel-plugin-require-context-hook'
process.env.NODE_ENV === 'test' && require('babel-plugin-require-context-hook/register')()

const requirePaths = require.context('.', false, /\.js$/)
let paths = []

requirePaths.keys().forEach(fileName => {
  if (fileName === './index.js') {
    return
  }

  paths = paths.concat(requirePaths(fileName).default)
})

paths = [{
  children: paths,
  component: Main,
  meta: {
    auth: true
  },
  name: 'main',
  path: '/',
  redirect: '/home'
}]

export default paths
